export default "__VITE_ASSET__BE$kY3aR__"